import * as React from 'react';
import { Flex } from "../..";
export var CardHeaderActionsWrapper = function (_a) {
    var actions = _a.actions;
    return (React.createElement(Flex, { lss: {
            flexWrap: 'wrap',
            mobile: {
                mt: 'sm'
            },
            desktop: {
                mt: 'none'
            }
        } }, actions));
};
//# sourceMappingURL=CardHeaderActionsWrapper.js.map